const headCells = [
  {
    label: 'Name',
    id: 'name',
  },
  { label: 'Email', id: 'email' },
  { label: 'User Id', id: 'userId' },
  { label: 'Group Name', id: 'groupName' },
  { label: 'Shift', id: 'shift' },
];

const createData = (name, email, userId, groupName, shift) => ({
  name,
  email,
  userId,
  groupName,
  shift,
});

export { headCells, createData };
